import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import WatchlistInnerTabNavigation from '@/components/watchlist/WatchlistInnerTabNavigation.vue';
import { CollectionType } from '@/enums/collection-type';
import { TabType } from '@/interfaces/inner-tabs';
import { useI18n } from '@/helpers/composables/useI18n';

import UserTitleList from '@/components/watchlist/my-lists/UserTitleList.vue';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useListsCount } from '@/helpers/composables/useListsCount';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyLists',
  emits: ["scrollToTop"],
  setup(__props) {

const Collections = () =>
	import(/* webpackChunkName: "collections" */ '@/components/watchlist/my-lists/Collections.vue');
const EmptyListSlider = () =>
	import(/* webpackChunkName: "empty-list-slider" */ '@/components/watchlist/empty-list-slider/EmptyListSlider.vue');



const userStore = useUserStore();
const filterStore = useFilterStore();
const { setLastActiveListsCollectionType } = useRoutingStore();

const { t, tc } = useI18n();

setLastActiveListsCollectionType(CollectionType.MY_LISTS);
useProvideClickoutPlacement('user_list');

const { customListsCount } = useListsCount();

const innerTabFilter = computed<TabType>(() => filterStore.currentFilters.inner_tab || TabType.WATCHLIST);

const innerTabs = computed(() => {
	return [
		{
			key: TabType.MY_LISTS,
			translation: `${t('WEBAPP_LISTS_COUNT', {
				listsCount: `${customListsCount.value}/${userStore.customListsLimit}`,
			})}`,
		},
		{
			key: TabType.WATCHLIST,
			translation: `${tc('WEBAPP_WATCHLIST')}`,
		},
		{
			key: TabType.SEENLIST,
			translation: `${tc('WEBAPP_SEEN')}`,
		},
		{
			key: TabType.LIKELIST,
			translation: `${tc('WEBAPP_LISTS_LIKED')}`,
		},
	];
});

const slides = [
	{
		title: tc('WEBAPP_LISTS_EMPTY_WATCHLIST_SLIDE_FIRST_TITLE'),
		message: tc('WEBAPP_LISTS_EMPTY_WATCHLIST_SLIDE_FIRST_MESSAGE'),
		image: `/${ASSETS_DIR}/img/lists/placeholder-custom-lists.png`,
		image2x: `/${ASSETS_DIR}/img/lists/placeholder-custom-lists@2x.png`,
	},
	{
		title: tc('WEBAPP_WATCHLIST'),
		message: t('WEBAPP_LISTS_EMPTY_SHOW_WATCHLIST_MESSAGE', {
			useTvShowTracking: t('WEBAPP_LISTS_USE_TV_SHOW_TRACKING', {
				tvShowTracking: tc('WEBAPP_LISTS_TV_SHOW_TRACKING'),
			}),
		}) as string,
		image: `/${ASSETS_DIR}/img/lists/placeholder-watchlist.png`,
		image2x: `/${ASSETS_DIR}/img/lists/placeholder-watchlist@2x.png`,
	},
	{
		title: tc('WEBAPP_LISTS_EMPTY_WATCHLIST_SLIDE_THIRD_TITLE'),
		message: tc('WEBAPP_LISTS_EMPTY_WATCHLIST_SLIDE_THIRD_MESSAGE'),
		image: `/${ASSETS_DIR}/img/lists/placeholder-seen.png`,
		image2x: `/${ASSETS_DIR}/img/lists/placeholder-seen@2x.png`,
	},
];

return { __sfc: true,Collections, EmptyListSlider, userStore, filterStore, setLastActiveListsCollectionType, t, tc, customListsCount, innerTabFilter, innerTabs, slides, WatchlistInnerTabNavigation, UserTitleList }
}

})